import { render, staticRenderFns } from "./MovieMinimalPostersTab.vue?vue&type=template&id=b1784bd2&scoped=true&"
import script from "./MovieMinimalPostersTab.vue?vue&type=script&lang=js&"
export * from "./MovieMinimalPostersTab.vue?vue&type=script&lang=js&"
import style0 from "./MovieMinimalPostersTab.vue?vue&type=style&index=0&id=b1784bd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1784bd2",
  null
  
)

export default component.exports